import type { ProviderImportProfile } from '@timelyapp/integration-cloud-api-spec';
import React from 'react';
import { getActiveImportProfile } from '../utils/util.profileLabels';

export function useActiveImportProfile(
  profiles: ProviderImportProfile[] | undefined,
  activeKey?: string | null
): ProviderImportProfile | undefined {
  return React.useMemo(() => getActiveImportProfile(profiles, activeKey), [profiles, activeKey]);
}
